"use client";

import Image from "next/image";
import { useState } from "react";

export function Logo({ className = "h-10 w-auto" }: { className?: string }) {
  const [error, setError] = useState(false);

  if (error) {
    return <div className={className} aria-hidden="true" />;
  }

  return (
    <Image
      src="/uniui_original_remastered_horizontal.png"
      alt="UniUI"
      width={256}
      height={64}
      className={className}
      priority
      onError={() => setError(true)}
    />
  );
}
